var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 295,
    viewBox: "0 0 201 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.336 246.312L72.8955 201.595L52.5948 146.413L-5.26578 135.945L-42.8253 180.662L-22.5224 235.846L35.336 246.312Z",
    fill: "#598BEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2925 88.0089L73.9896 32.8254L16.129 22.357L-21.4286 67.0722L-1.12578 122.256L56.7348 132.724L94.2925 88.0089Z",
    fill: "#598BEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9981 140.505L86.301 195.688L144.162 206.157L181.719 161.442L161.416 106.258L103.556 95.7896L65.9981 140.505Z",
    fill: "#598BEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavBackground);
export default __webpack_public_path__ + "static/media/nav-background.302bf9fe73f0098a37dad0c166022b2d.svg";
export { ForwardRef as ReactComponent };